import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { EnvironmentService } from './environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {
  private apiUrl = `${this.environmentService.activeAppBaseUrl}/api/Account/forgotpassword`; // Replace with your API endpoint

  constructor(private http: HttpClient,private environmentService: EnvironmentService) { }

  sendResetLink(email: string): Observable<any> {
    return this.http.post<any>(this.apiUrl, { email })
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
